<template>
  <div :class="$style.pageContainer">
    <router-view />
    <portal-target name="modal" />
  </div>
</template>

<script>
import { PortalTarget } from 'portal-vue';
import { getNewTasks } from '@/api/methods/tasks';
import { getDiagnosticsData } from '@/api/methods/settings';
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import dayjs from 'dayjs';
import { dateRouter } from './helpers/filters';

Vue.use(VueToast);

export default {
  components: {
    PortalTarget,
  },
  data: () => ({
    interval: null,
  }),
  computed: {
    dayTrial() {
      return this.$store.getters['software/dayTrial'];
    },
    isUserNotRegistered() {
      return this.$store.getters['software/isUserNotRegistered'];
    },
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    'user.authenticated': {
      async handler(newVal) {
        if (newVal) {
          await this.$store.dispatch('software/updateCompanyInfo');
          await this.createdCompanyInfo();

          const sessionDiagnosticsAgent = sessionStorage.getItem('sessionDiagnosticsAgent');
          const notifyData = localStorage.getItem('notifyData');

          if (!sessionDiagnosticsAgent && notifyData === 'true') {
            await this.getDiagnosticsInfo();
          }
        }
      },
      immediate: true,
    },
  },
  async created() {
    await this.getNotifications();
    this.interval = setInterval(this.getNotifications, 2000);
  },
  methods: {
    getNewVersion() {
      return this.$store.dispatch('software/updateSoftwareInfo');
    },

    getMessage(message, func) {
      Vue.$toast.open({
        message,
        type: 'info',
        duration: 10000,
        onClick: func || this.openUpdates,
      });
    },
    async createdCompanyInfo() {
      const now = Date.now();
      const checkFrequency = localStorage.getItem('checkFrequency');
      const lastUpdateCheck = localStorage.getItem('lastUpdateCheck');
      const storedSelectedDay = localStorage.getItem('selectedDay') || 5;
      const daysInMilliseconds = storedSelectedDay * 24 * 60 * 60 * 1000;

      const sessionUpdateCheck = sessionStorage.getItem('sessionUpdateCheck');

      if (this.isUserNotRegistered && this.dayTrial > 0 && this.dayTrial < 10) {
        this.getMessage(this.$t('toast.trialDaysRemaining', { dayTrial: this.dayTrial }), this.openAboutProgram);
      }
      if (checkFrequency === 'do_not_check') return;
      if ((checkFrequency === 'every_startup' || !checkFrequency) && !sessionUpdateCheck) {
        const responce = await this.getNewVersion();
        if (responce !== 404) this.getMessage(this.$t('toast.newProgramVersionAvailable'));
      } else if (
        checkFrequency === 'every_day'
          && (!lastUpdateCheck || now - lastUpdateCheck >= daysInMilliseconds)
          && !sessionUpdateCheck
      ) {
        await this.getNewVersion();
        this.getMessage();
      }
    },
    async getNotifications() {
      const result = await getNewTasks();
      if (result !== 'error' && result === true) {
        Vue.$toast.open({
          message: this.$t('toast.newSecurityBreachEvents'),
          type: 'info',
          duration: 5000,
          onClick: this.openNotifications,
        });

        this.$store.commit('navigation/setNewNotifications', true);
      }
    },

    async getDiagnosticsInfo() {
      const day = localStorage.getItem('numberDays');
      let currentValue = dayjs();
      if (+day) currentValue = currentValue.subtract(+day, 'day');
      const date = dateRouter(currentValue);
      const { data } = await getDiagnosticsData(date);
      if (data.length) {
        const isMissingData = data.find((item) => !item?.lastLogTime);
        if (isMissingData) {
          this.getMessage(this.$t('toast.missingRelevantDataFromSomeUsers'), this.openDiagnosticsAgent);
          sessionStorage.setItem('sessionDiagnosticsAgent', currentValue);
        }
      }
    },
    openAboutProgram() {
      this.$router.push('/program/aboutProgram');
    },
    openUpdates() {
      this.$router.push('/program/updatesProgram');
    },
    openNotifications() {
      const routeData = this.$router.resolve({
        name: 'notifications',
      });
      window.open(routeData.href, '_blank');
    },
    openDiagnosticsAgent() {
      this.$router.push('/settings/diagnostics');
    },
  },
};
</script>
<style lang="scss" module>
  .pageContainer {
    height: 100%;
  }
</style>
<style>
  .v-toast__item--info {
    background-color: #2985bf;
  }
</style>
